/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import PartnerGst from "./PartnerGst.container";

export default PartnerGst;
